/** The API caps a page at 50, and a tenant can have more roles than that. */
export const allPages = async <T>(
  request: ( pageToken?: string ) => Promise<{ items?: T[]; nextPageToken?: string }>,
): Promise<T[]> => {
  const items: T[] = [];
  const seenTokens = new Set<string>();
  let pageToken: string | undefined;

  do {
    const response = await request( pageToken );
    items.push( ...( response.items ?? [] ) );
    pageToken = response.nextPageToken || undefined;
    if ( pageToken && seenTokens.has( pageToken ) ) {
      break;
    }
    pageToken && seenTokens.add( pageToken );
  } while ( pageToken );

  return items;
};
